import React, { useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './shilpadoc.css';
import shilpa from '../../../../assets/images/Doctorsimages/dr.shilpa.png';
import logo from '../../../../assets/images/aboutuslogo.png';
import homeo1 from './../../../../assets/images/beforeandafterimages/skin.png'
// import psorasis1 from './../../../../assets/images/beforeandafterimages/psorasis1.jpeg'
import psorasis2 from './../../../../assets/images/beforeandafterimages/psorasis2.jpeg'
import vitiligo from './../../../../assets/images/beforeandafterimages/vitiligo.jpeg'
import img4 from "../../../../assets/images/autoscroll4.jpg";
const Drshilpa = () => {
  const profileRef = useRef();

  const handleDownloadPdf = () => {
    const container = profileRef.current;
    container.classList.add('drshilpa-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: 794,
        windowWidth: 794
      }).then(canvas => {
        container.classList.remove('drshilpa-pdf-mode');

        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
          }
        });

        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const availableWidth = pdfWidth - 10; 
        
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;

        pdf.addImage(imgData, 'JPEG', 5, 0, imgWidth, imgHeight);
        pdf.save('Dr_Shilpa_Vikas_Profile.pdf');
      });
    }, 150);
  };

  return (
    <div className="drshilpa-page-wrapper">
      <div className="drshilpa-download-area">
        <button onClick={handleDownloadPdf} className="drshilpa-btn">
          Download PDF Profile
        </button>
      </div>

      <div className="drshilpa-pdf-container" ref={profileRef}>
        <div className="drshilpa-header">
          <div className="drshilpa-header-inner">
            <img src={logo} alt="Logo" className="drshilpa-logo" />
            <div className="drshilpa-clinic-info">
              <h4 className="drshilpa-clinic-name">HCURA MULTISPECIALITY CLINIC</h4>
            </div>
          </div>
        </div>

        <div className="drshilpa-flex-layout">
          <div className="drshilpa-sidebar">
            <div className="drshilpa-photo-wrap">
              <img src={shilpa} alt="Dr. Shilpa" className="drshilpa-photo" />
            </div>

            <div className="drshilpa-stats-section">
              <div className="drshilpa-stat-item">
                <h2 className="drshilpa-stat-val">20000+</h2>
                <p className="drshilpa-stat-lbl"> <strong>PATIENTS TREATED</strong> </p>
              </div>
              <div className="drshilpa-stat-item">
                <h2 className="drshilpa-stat-val">50+</h2>
                <p className="drshilpa-stat-lbl"> <strong>CELEBRITIES TREATED</strong> </p>
              </div>
              <div className="drshilpa-stat-item">
                <h2 className="drshilpa-stat-val">3000+</h2>
                <p className="drshilpa-stat-lbl"> <strong>HAIR TREATMENTS</strong> </p>
              </div>
              <div className="drshilpa-stat-item">
                <h2 className="drshilpa-stat-val">2500+</h2>
                <p className="drshilpa-stat-lbl"> <strong>SKIN TREATMENTS</strong> </p>
              </div>
            </div>

            <div className="drshilpa-expertise-section">
              <h3 className="drshilpa-side-title">Expertise</h3>
              <div className="drshilpa-side-line"></div>
              <ul className="drshilpa-side-list">
                <li>Homeopathy</li>
                <li>Cosmetology</li>
                <li>Nutrition</li>
                <li>Counselling</li>
              </ul>
            </div>
          </div>

          <div className="drshilpa-main-body">
            <div className="drshilpa-intro">
              <h1 className="drshilpa-name">Dr. Shilpa Vikas</h1>
              <p className="drshilpa-credentials">BHMS, MSc Psychology, FMC, Nutritionist, NAHI</p>
              <p className="drshilpa-sub">Director - Homeopathy & Cosmetology</p>
              <p className="drshilpa-hcura">
               <strong>Hcura Multispeciality Clinic</strong>
              </p>
            </div>

            <div className="drshilpa-quote-box">
              <p className="drshilpa-quote-text">
                "A Good Doctor Treats the Disease, but Great Doctor Restores the Health, Youth and Beauty."
              </p>
            </div>

            <div className="drshilpa-content-section">
              <div className="drshilpa-exp-row">
                <span className="drshilpa-bullet">.</span>
                <div className="drshilpa-exp-text">
                  <strong>Hcura Multispeciality Clinic</strong>
                  <p className="drshilpa-exp-sub">Current Designation: Director</p>
                </div>
              </div>
              <div className="drshilpa-exp-row">
                <span className="drshilpa-bullet">.</span>
                <div className="drshilpa-exp-text">
                  <strong>Provitale Health Homeopathy & Aesthetic</strong>
                  <p className="drshilpa-exp-sub">Director / CEO</p>
                </div>
              </div>
              <div className="drshilpa-exp-row">
                <span className="drshilpa-bullet">.</span>
                <div className="drshilpa-exp-text">
                  <strong>Experience in Renowned Homeopathic Clinics</strong>
                </div>
              </div>
            </div>

            <div className="drshilpa-content-section">
              <h2 className="drshilpa-section-title">MEDIA PRESENCE & CELEBRITY CARE</h2>
              <div className="drshilpa-list-row">
                Trusted by <strong>50+ celebrities</strong>; featured in <strong>600-700 TV talks</strong> on TV9, Suvarna News, News 18 Kannada, etc.
              </div>
            </div>

            <div className="drshilpa-content-section">
              <h2 className="drshilpa-section-title">CLINICAL RESULTS</h2>
              <div className="drshilpa-image-grid">
               
                <div className="drshilpa-image-item"><img src={psorasis2} alt="Result 3" /></div>
                <div className="drshilpa-image-item"><img src={vitiligo} alt="Result 4" /></div>
                <div className="drshilpa-image-item"><img src={img4} alt="Result 2" /></div>
                 <div className="drshilpa-image-item"><img src={homeo1} alt="Result 1" /></div>
                
              </div>
            </div>
          </div>
        </div>

        <div className="drshilpa-footer">
          <p>Restoring Health, Youth, and Beauty through Holistic Care</p>
        </div>
      </div>
    </div>
  );
};

export default Drshilpa;
